// extracted by mini-css-extract-plugin
export default {"with-shadow":"Calendar_with-shadow__EKMT4","disabledChange":"Calendar_disabledChange__37iOz","custom-calendar":"Calendar_custom-calendar__FKc-G"};